var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundLogoAcium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 496.082,
    viewBox: "0 0 500 496.082",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1216",
    "data-name": "Caminho 1216",
    d: "M127.071,1076.41l99.2-20.713L376.441,757.426l151.206,297.235,99.423,21.749-250-496.082Z",
    transform: "translate(-127.071 -580.328)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundLogoAcium);
export default __webpack_public_path__ + "static/media/backgroundLogoAcium.9dbb5daeb65b82cc78624456379f5c0d.svg";
export { ForwardRef as ReactComponent };